// https://momentjs.com/docs
import moment from 'moment';
import { i18n } from '@src/i18n-setup';
import isSameDate from '@utils/date/is-same-date';
/**
 * Gets the translated distance between two dates until 1 day difference
 * and assumes 'today' as the second date if one isn't passed.
 * Accepts JS Date objects or string in ISO 8601 format.
 *
 * eg.: 'Today', '2 days ago', '1 year ago', ...
 * @private
 * @param {String|Object} end
 * @param {String|Object} start
 * @return {String|Object} The translated value to display
 */
export default function getTimeDistance(start, end = new Date()) {
  moment.locale(i18n.locale);

  if (isSameDate(start, end)) {
    return i18n.t('dashboard.updates.subtitle.today');
  }

  return moment(start).from(end);
}
